import { Provider } from './store';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { App, ConfigProvider as EuiConfigProvider } from '@emooa/ui';
import Router from './Router';

export default () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#1a6cba',
          colorLink: '#1a6cba',
          borderRadius: 4,
          fontSize: 13,
          colorText: '#333',
        },
        components: {
          Layout: {
            padding: 0,
            siderBg: '#304056',
          },
          Menu: {
            fontSize: 14,
            activeBarBorderWidth: 0,
            itemBorderRadius: 0,
          },
          Breadcrumb: {
            fontSize: 14,
          },
          Descriptions: {
            paddingLG: 16,
          },
        },
      }}
    >
      <EuiConfigProvider
        scheme="light"
        theme={{
          token: {
            colorPrimary: '#1a6cba',
            colorLink: '#1a6cba',
            borderRadius: 4,
            fontSize: 13,
            colorText: '#333',
          },
        }}
      >
        <App>
          <Provider>
            <Router />
          </Provider>
        </App>
      </EuiConfigProvider>
    </ConfigProvider>
  );
};
